import httpClient from '@xto10x/core/lib/httpClient';

const userboardApi = {
  getUserboardData: requestBody =>
    httpClient.get('/v1/dashboard/user', requestBody),
  getUserboardTeamData: requestBody =>
    httpClient.get('/v1/dashboard/team', requestBody),
  getUserboardObjectives: requestBody =>
    httpClient.post('/v1/objective/user-view', requestBody),
  sendReminders: requestBody =>
    httpClient.post('/v1/notification-nudge', requestBody),
  getUserboardDepartmentData: requestBody =>
    httpClient.get('/v1/dashboard/departments', requestBody)
};

export default userboardApi;
